export const PAGE_SIZES = [25, 50, 75, 100];

export default PAGE_SIZES;
